module.exports = __webpack_public_path__ + "media/1-0_Exploration.6e04079f.mp4";